module.exports = __webpack_public_path__ + "static/podcast-hero-mobile.04538246.webp";